import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
const _ = {
    find: require('lodash/find'),
    map: require('lodash/map'),
};

const VoiceActions = require('../../actions/VoiceActions');
const VoiceStore = require('../../stores/VoiceStore');

const ProjectActions = require('../../actions/ProjectActions');
const ProjectStore = require('../../stores/ProjectStore');

import SortableTableClassic from '../table/SortableTableClassic';
import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';

const propTypes = {
    channelId: PropTypes.number.isRequired,
    orgName: PropTypes.string.isRequired,
    className: PropTypes.string,
    heading: PropTypes.string,
};

const defaultProps = {
    className: '',
    heading: 'Voice Usage Statistics',
};

class PollyUsageView extends React.Component {
    constructor(props) {
        super(props);
        let channelState = VoiceStore.getChannelState(props.channelId);
        if (!channelState.usage) {
            channelState = null; // need to call the action to get usage
        }
        
        const projectStoreState = ProjectStore.getState();
        const projects = projectStoreState.initialized ? projectStoreState.projects : null;
        const shortCourseProjects = projectStoreState.initialized ? projectStoreState.shortCourseProjects : null;

        this.state = {
            actionId: null,
            channelState,
            projects,shortCourseProjects,
        };
        this.unsubscribes = [
            VoiceStore.listen(this.onStoreChange),
            ProjectStore.listen(this.onStoreChange),
        ];
    }
    
    componentDidMount() {
        let actionId = null;
        let projectActionId = null;
        if (!this.state.channelState) {
            actionId = uuid.v4();
        }
        if (!this.state.projects) {
            projectActionId = uuid.v4();
        }
        this.setState({actionId,projectActionId},()=>{
            if(actionId) {
                VoiceActions.adminGetChannelUsage(actionId,this.props.channelId);
            }
            if (projectActionId) {
                ProjectActions.getAllProjects(projectActionId);
            }
        });
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onRefresh=()=>{
        let actionId = uuid.v4();
        this.setState({actionId},()=>{
            VoiceActions.adminGetChannelUsage(actionId,this.props.channelId);
        });
    }
    
    onStoreChange=(storeState)=>{
        if (storeState.action.id === this.state.actionId) { 
            if (storeState.action.error) {
                this.setState({error: storeState.action.error, actionId: null});
            }
            else {
                let channelState = VoiceStore.getChannelState(this.props.channelId);
                this.setState({channelState, actionId: null, error: null});
            }
        };
        if (storeState.action.id === this.state.projectActionId) {
            if (storeState.action.error) {
                this.setState({projectError: storeState.action.error, projectActionId: null});
            }
            else {
                const projectStoreState = ProjectStore.getState();
                const projects = projectStoreState.projects || [];
                const shortCourseProjects = projectStoreState.shortCourseProjects || [];
                this.setState({projects, shortCourseProjects, projectActionId:null, projectError: null});
            }
        }
    }
    
    render() {
        if (this.state.error) {
            return (
                <ErrorBox error={this.state.error} />
            )
        }
        if (this.state.projectError) {
            return (
                <ErrorBox error={this.state.projectError} />
            )
        }
        if (!this.state.channelState || !this.state.projects) {
            return <LoadingMainContent/>
        }
        let { activityUsage, shortCourseUsage } = this.state.channelState.usage;
        const projects = this.state.projects;
        const shortCourseProjects = this.state.shortCourseProjects;
        activityUsage = _.map(activityUsage,(row)=>{
            let project = _.find(projects,{id: Number(row.project_id)});
            let project_name = project ? project.name : '';
            return {...row, project_name};
        });
        shortCourseUsage = _.map(shortCourseUsage,(row)=>{
            let project = _.find(shortCourseProjects,{id: Number(row.project_id)});
            let project_name = project ? project.name : '';
            return {...row, project_name};
        });
        
        return (
            <div>
                <SortableTableClassic
                    title="Voice Activity Usage"
                    totalName="Rows"
                    additionalTotalRowKeys={["calls","characters"]}
                    onRefresh={this.onRefresh}
                    refreshDisabled={!!this.state.actionId}
                    formatTotals
                    uniqueRowKey="id"
                    rows={activityUsage}
                    columns={
                        [
                            {
                                displayName: 'Year and Month',
                                key:'ym',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'project',
                                key:'project_name',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'Activity',
                                key:'title',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'share',
                                key:'share_id',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Engine',
                                key:'engine',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Stream',
                                key:'stream',
                                size: 2,
                                type: 'bool'
                            },
                            {
                                displayName: 'Calls',
                                key:'calls',
                                size: 2,
                                type: 'number'
                            },
                            {
                                displayName: 'Characters',
                                key:'characters',
                                size: 3,
                                type: 'number'
                            },
                        ]
                    }
                    displayColumnCallbacksRow={{
                        title: (row) => {
                            let url = `/project/${this.props.channelId}/${row.project_id}/activity/${row.activity_id}`;
                            return (
                                <a className="trad-link" href={url}>
                                    {row.title}
                                </a>
                            );
                        },
                        calls: (row) => {
                            return Number(row.calls).toLocaleString();
                        },
                        characters: (row) => {
                            return Number(row.characters).toLocaleString();
                        },
                    }}
                />
                <SortableTableClassic
                    title="Voice Short Course Usage"
                    totalName="Rows"
                    additionalTotalRowKeys={["calls","characters"]}
                    onRefresh={this.onRefresh}
                    refreshDisabled={!!this.state.actionId}
                    formatTotals
                    uniqueRowKey="id"
                    rows={shortCourseUsage}
                    columns={
                        [
                            {
                                displayName: 'Year and Month',
                                key:'ym',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'project',
                                key:'project_name',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'Short Course',
                                key:'title',
                                size: 4,
                                type: 'string'
                            },
                            {
                                displayName: 'Engine',
                                key:'engine',
                                size: 2,
                                type: 'string'
                            },
                            {
                                displayName: 'Stream',
                                key:'stream',
                                size: 2,
                                type: 'bool'
                            },
                            {
                                displayName: 'Calls',
                                key:'calls',
                                size: 2,
                                type: 'number'
                            },
                            {
                                displayName: 'Characters',
                                key:'characters',
                                size: 3,
                                type: 'number'
                            },
                        ]
                    }
                    displayColumnCallbacksRow={{
                        title: (row) => {
                            let url = `/project/${this.props.channelId}/${row.project_id}/short_course/${row.short_course_id}`;
                            return (
                                <a className="trad-link" href={url}>
                                    {row.title}
                                </a>
                            );
                        },
                        calls: (row) => {
                            return Number(row.calls).toLocaleString();
                        },
                        characters: (row) => {
                            return Number(row.characters).toLocaleString();
                        },
                    }}
                />
            </div>
        )
    } // render
}

PollyUsageView.propTypes = propTypes;
PollyUsageView.defaultProps = defaultProps;

export default PollyUsageView;